import { NotMeasuredSettingsState } from './interface';

export const initialState: NotMeasuredSettingsState = {
  settings: { data: null, status: null },
  saveStatus: null,
  deviceMap: { data: [], status: null },
};
